import './App.css';
import { useState, useEffect } from 'react';
import { DropdownMenu, Button } from '@radix-ui/themes';
import GoogleAnalytics from './components/GoogleAnalytics';

const ImageBaseURL = 'https://dlcdnzt.asus.com/animeplay/assets/images';
const SpeedyRunner = `${ImageBaseURL}/speedy_runner.svg`;
const SnakeVenture = `${ImageBaseURL}/snake_venture.svg`;
const AeroInvaders = `${ImageBaseURL}/aero_invaders.svg`;
const BrickSmasher = `${ImageBaseURL}/brick_smasher.svg`;
const goBackArrow = `${ImageBaseURL}/arrow_back.svg`;

/** Constant variables */
const SpeedyRunnerId = 'd0a98ad8-e896-47f3-818f-a4497a73c29d';
const SnakeVentureId = '1a19ec9e-94e6-4ef3-a22b-d9050e8e6145';
const AeroInvadersId = '3ebdfae6-42bd-48c5-9082-9f6bd6c6f141';
const BrickSmasherId = '2101de8e-7069-4165-898c-bbae5c2cbc3f';
const languagesData = [
	{
		id: 'ww',
		name: 'Global',
		title: 'ROG LEADERBOARD',
		boardTimeTitle: 'Time Taken: ',
		games: [
			{ id: SpeedyRunnerId, name: 'Speedy Runner', img: SpeedyRunner },
			{ id: SnakeVentureId, name: 'Snake Venture', img: SnakeVenture },
			{ id: AeroInvadersId, name: 'Aero Invaders', img: AeroInvaders },
			{ id: BrickSmasherId, name: 'Brick Smasher', img: BrickSmasher },
		],
	},
	{
		id: 'tw',
		name: '台灣',
		title: '玩家排行榜',
		boardTimeTitle: '花費時間: ',
		games: [
			{ id: SpeedyRunnerId, name: '跑酷競速', img: SpeedyRunner },
			{ id: SnakeVentureId, name: '蛇蛇探險', img: SnakeVenture },
			{ id: AeroInvadersId, name: '迷航艦隊', img: AeroInvaders },
			{ id: BrickSmasherId, name: '磚塊砰砰', img: BrickSmasher },
		],
	},
	{
		id: 'my',
		name: 'Malaysia',
		title: 'ROG LEADERBOARD',
		boardTimeTitle: 'Time Taken: ',
		games: [
			{ id: SpeedyRunnerId, name: 'Speedy Runner', img: SpeedyRunner },
			{ id: SnakeVentureId, name: 'Snake Venture', img: SnakeVenture },
			{ id: AeroInvadersId, name: 'Aero Invaders', img: AeroInvaders },
			{ id: BrickSmasherId, name: 'Brick Smasher', img: BrickSmasher },
		],
	},
];

function App() {
	const url = new URL(window.location);
	const userId = url.searchParams.get('userId') || '';
	const API_URL = process.env.REACT_APP_API_URL + '/animeplay/api/leaderboards';
	const [language, setLanguage] = useState(url.searchParams.get('region') || 'ww');
	const [gameId, setGameId] = useState(url.searchParams.get('gameId') || languagesData[0].games[0].id);
	const isDefault =
		languagesData.find((data) => data.id === language).games.find((game) => game.id === gameId) === undefined;
	const [leaderBoardData, setLeaderBoardData] = useState(null);
	const [gameTitle, setGameTitle] = useState('');
	const [timeTitle, setTimeTitle] = useState('');

	useEffect(() => {
		let url = `${API_URL}?gameId=${gameId}&region=${language}`;
		if (userId) url += `&userId=${userId}`;

		fetch(url)
			.then((res) => res.json())
			.then((json) => setLeaderBoardData(json.data))
			.catch((error) => error);
		setGameTitle(languagesData.find((data) => data.id === language).title);
		setTimeTitle(languagesData.find((data) => data.id === language).boardTimeTitle);
	}, [language, gameId, userId]);

	/**
	 * Function to update params
	 *
	 * @param {String} name - The param name
	 * @param {String} value - The param value
	 */
	const updateParams = (name, value) => {
		url.searchParams.set(name, value);
		window.history.pushState({}, '', url.toString());
	};

	return (
		<div>
			<GoogleAnalytics />
			<div className="w-full m-auto leaderboard-container flex flex-col relative">
				<div className="bg-black anime-leaderboard-header relative">
					<div className="flex w-full absolute top-0 justify-between items-center tool-bar">
						<div>
							<a href="uniwebview://action?key=value&anotherKey=anotherValue">
								<img src={goBackArrow} className="mr-2.5 go-back" alt="back" />
							</a>
							<img src={`${ImageBaseURL}/animeplay.webp`} className="animeplay-logo inline" alt="anime" />
						</div>
						<div>
							<DropdownMenu.Root>
								<DropdownMenu.Trigger>
									<Button className="lang-btn">
										<div className="w-14 lang-name">{languagesData.find((data) => data.id === language).name}</div>
										<img src={`${ImageBaseURL}/union.svg`} alt="" />
									</Button>
								</DropdownMenu.Trigger>
								<DropdownMenu.Content>
									{languagesData.map((data) => (
										<DropdownMenu.Item
											key={data.id}
											onClick={() => {
												setLanguage(data.id);
												updateParams('region', data.id);
											}}
											className="lang-option-name"
										>
											{data.name}
										</DropdownMenu.Item>
									))}
								</DropdownMenu.Content>
							</DropdownMenu.Root>
						</div>
					</div>
					<div className="campaign-content left-0 absolute text-center right-0">
						<div className="relative flex flex-col">
							<div>
								<img src={`${ImageBaseURL}/rog_logo.gif`} className="rog-logo m-auto" alt="" />
							</div>
							<div className="title">{gameTitle}</div>
						</div>
					</div>
					<div className="flex game-list justify-center absolute bottom-0 flex-col items-center">
						<div>
							<img src={`${ImageBaseURL}/scroll.svg`} className="scroll-icon" alt="" />
						</div>
						<div className="flex justify-between w-full">
							{languagesData
								.find((data) => data.id === language)
								.games.map((game, _index) => {
									return (
										<div
											key={game.id + game.name}
											className={`game-section ${isDefault && _index === 0 && 'game-option'} ${
												gameId === game.id && 'game-option'
											} ${language === 'tw' && 'game-tc'}`}
											onClick={() => {
												setGameId(game.id);
												updateParams('gameId', game.id);
											}}
										>
											<img src={game.img} className="game-icon" alt="" />
											<div className="game-title">{game.name}</div>
										</div>
									);
								})}
						</div>
					</div>
				</div>
				<div className="anime-leaderboard-body overflow-y-auto relative">
					{leaderBoardData ? (
						leaderBoardData.topPlayers.map((userData, index) => {
							return (
								<div
									className={`static-rank m-0 ${leaderBoardData.user.rank === userData.rank && 'light-rank'}`}
									key={userData.userId + index}
								>
									<div
										className={`static-board bg-black flex items-center justify-between ${
											userData.rank <= 3 && 'board-rank' + userData.rank
										} ${leaderBoardData.user.rank === userData.rank && 'board-light'}`}
										key={userData.userId + index}
									>
										<div className="flex flex-row items-center">
											<div className="user-rank">
												{userData.rank <= 3 ? (
													<img src={`${ImageBaseURL}/rank${userData.rank}.svg`} className="rank-icon" alt="rank" />
												) : (
													(userData.rank < 10 && '0') + userData.rank
												)}
											</div>
											<div className="user-info flex flex-col">
												<div className="name">
													{userData.nickname} {leaderBoardData.user.rank === userData.rank && '(YOU)'}
												</div>
												<div className="score">{userData.score}</div>
											</div>
										</div>
										<div className="time">
											{timeTitle}
											{userData.time}
										</div>
									</div>
								</div>
							);
						})
					) : (
						<div className="text-center">Loading...</div>
					)}
					{leaderBoardData?.user && leaderBoardData.user.rank > 100 && (
						<div className="light-rank sticky bottom-1">
							<div className="w-full board-red">
								<div className={'static-board bg-black flex items-center board-light justify-between last-board'}>
									<div className="flex flex-row items-center">
										<div className="user-rank">{leaderBoardData.user.rank}</div>
										<div className="user-info flex flex-col">
											<div className="name">{leaderBoardData.user.nickname} (YOU)</div>
											<div className="score">{leaderBoardData.user.score}</div>
										</div>
									</div>
									<div className="time">
										{timeTitle}
										{leaderBoardData.user.time}
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default App;
